import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches,
    getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";
class MotoAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            vehicles: [],
            customers: [],
            loading: false,
            isLoad: true,
            brands: [],
            models: [],
            selectedBrand: '',
            selectedModel: '',
            formData: {
                brand: '',
                branch_id: '',
                customer_id: '',
                model: '',
                plate: '',
                year: '',
                km: '',
                chassis_no: '',
                engine_no: '',
                package_name: '',
                engine_size: '',
                key_no: '',
                details: '',
                vehicleImages: [],
                maintenance_date: '',
                next_maintenance_date: '',
                inspection_date: '',
                next_inspection_date: '',
                gear_type: '',
                is_motor: true,
            }
        }
    }
    async componentDidMount() {
        try {
            this.getBrands();
            this.setState({
                branches: await getBranches(),
                customers: await getCustomers(),
            });
        } catch (e) {
            throw e;
        }
    }
    getBrands = async () => {
        const response = await apiCall('business/vehicle/get-moto-brands', 'get', null);
        const brandOptions = response.map(brand => ({
            value: brand.id,
            label: brand.name
        }));
        this.setState({ brands: brandOptions });
    }

    handleBrandChange = async (selectedOption) => {
        const brand_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                brand: brand_id,
                model: ""
            },
            selectedBrand: option,
            models: []
        }));

        if (brand_id) {
            try {
                const response = await apiCall(`business/vehicle/get-moto-models/${brand_id}`, 'get', null);

                const modelOptions = response.map(model => ({
                    value: model.id,
                    label: model.name
                }));
                this.setState({ models: modelOptions });
            } catch (error) {
                console.error("Modelleri alırken hata oluştu:", error);
            }
        }
    }
    handleModelChange = async (selectedOption) => {
        const model_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                model: model_id
            },
            selectedModel: option,
        }));
    }
    handleChange = (e) => {
        const { id, value, files } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: files ? Array.from(files) : value
            }
        }));
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const vehicleFormData = new FormData();

        Object.keys(formData).forEach(key => {
            if (Array.isArray(formData[key])) {
                formData[key].forEach(file => {
                    vehicleFormData.append(`${key}[]`, file);
                });
            } else {
                vehicleFormData.append(key, formData[key]);
            }
        });

        try {

            const response = await apiCall('business/vehicle/add', 'post', vehicleFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message);
        } catch (e) {
            this.setState({ loading: false });
        }
    }
    render() {
        const { loading, branches, customers, brands, models, selectedBrand, selectedModel } = this.state;
        const { userPermissions } = this.props;
        const userHasNewVehiclePermission = userPermissions.includes('new vehicle');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Yeni Motosiklet Ekle"
                            Breadcrumb={[
                                { name: "Motosiklet", navigate: "vehicles" },
                                { name: "Yeni Motosiklet", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit} encType="multipart/form-data">
                                        <div className="body">
                                            <div className="row clearfix">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <small>Motosiklet ekleme ekranı ile müşterilerinizin Motosikletlerini hızlıca sisteme kaydedebilir, servis kaydı oluşturmadan önce tüm Motosiklet bilgilerini eksiksiz şekilde yönetebilirsiniz.</small>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <h6>Motosiklet Bilgileri</h6>
                                                    <div className="form-group">
                                                        <select name="customer_id" id='customer_id'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Müşteri Seçiniz</option>
                                                            {customers && (customers.map(customer => (
                                                                <option key={customer.id}
                                                                    value={customer.id}>{customer.name + ' ' + customer.surname}</option>
                                                            )))}

                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <select name="branch_id" id='branch_id'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Şube Seçiniz</option>
                                                            {branches && (branches.map(branch => (
                                                                <option key={branch.id}
                                                                    value={branch.id}>{branch.name}</option>
                                                            )))}

                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <input name="plate"
                                                            id="plate"
                                                            className="form-control"
                                                            placeholder="Plaka"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Select
                                                            className="border-danger"
                                                            value={selectedBrand}
                                                            onChange={this.handleBrandChange}
                                                            options={brands}
                                                            placeholder="Marka Seçin"
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                    ...provided,
                                                                    borderColor: state.isFocused ? 'red' : 'red',
                                                                    boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                                    '&:hover': { borderColor: 'red' }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Select
                                                            className="border-danger"
                                                            value={selectedModel}
                                                            onChange={this.handleModelChange}
                                                            options={models}
                                                            placeholder="Model Seçin"
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                    ...provided,
                                                                    borderColor: state.isFocused ? 'red' : 'red',
                                                                    boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                                    '&:hover': { borderColor: 'red' }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="year"
                                                            id="year"
                                                            className="form-control"
                                                            placeholder="Model Yılı"
                                                            type="number"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <textarea name="details"
                                                            id="details"
                                                            className="form-control"
                                                            placeholder="Motosiklet detayları"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="maintenance_date"
                                                            className="date-placeholder text-cyan">
                                                            Bakım tarihi
                                                        </label>
                                                        <input name="maintenance_date"
                                                            id="maintenance_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="inspection_date"
                                                            className="date-placeholder text-cyan">
                                                            Muayene tarihi
                                                        </label>
                                                        <input name="inspection_date"
                                                            id="inspection_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <h6>&nbsp;</h6>
                                                    <div className="form-group">
                                                        <select name="gear_type" id='gear_type'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Vites Tipi Seçiniz</option>
                                                            <option value="otomatik">Otomatik</option>
                                                            <option value="manuel">Manuel</option>

                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <input name="km"
                                                            id="km"
                                                            className="form-control"
                                                            placeholder="Km"
                                                            type="number"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="chassis_no"
                                                            id="chassis_no"
                                                            className="form-control"
                                                            placeholder="Şase No"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="key_no"
                                                            id="key_no"
                                                            className="form-control"
                                                            placeholder="Anahtar No"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label htmlFor="next_maintenance_date"
                                                            className="date-placeholder text-cyan">
                                                            Sonraki bakım tarihi
                                                        </label>
                                                        <input name="next_maintenance_date"
                                                            id="next_maintenance_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="next_inspection_date"
                                                            className="date-placeholder text-cyan">
                                                            Sonraki muayene tarihi
                                                        </label>
                                                        <input name="next_inspection_date"
                                                            id="next_inspection_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="vehicleImages"
                                                            id="vehicleImages"
                                                            className="form-control"
                                                            type="file"
                                                            multiple={true}
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="body">
                                                <div className="row clearfix justify-content-center">
                                                    <div className="col-lg-6 col-md-12">
                                                        {loading ? (
                                                            <button className="btn btn-outline-primary btn-block"
                                                                disabled={true}
                                                                style={{ textAlign: "-webkit-center" }}>
                                                                Lütfen Bekleyin...<ReactLoading type="spin"
                                                                    width={'24px'}
                                                                    height={'24px'}
                                                                    color="#268bd2"></ReactLoading>
                                                            </button>
                                                        ) :
                                                            <button disabled={!userHasNewVehiclePermission}
                                                                className="btn btn-outline-primary btn-block"
                                                                type="submit">
                                                                Güncelle
                                                            </button>}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(MotoAdd)));
